import React, { useContext, useState } from 'react';

import {
  useResponsiveParams,
  QuantaFormik,
  QuantaInput,
  QuantaForm,
  DataGrid,
  MixedGridGroup,
  InputGridGroup,
  DataGridGroup,
  Text,
  RadioGroup,
  Button,
} from 'quanta-ui';
import {Loading} from 'quanta-flows/modules/layout';
import { useQuery } from '@apollo/client';
import {
  CUSTOMER_INDIVIDUAL_DROPDOWN_DETAIL,
  GET_BUY_HEALTH_POLICY_VAR_DETAILS,
  GET_CUSTOMER_TYPE_DOMAIN,
  GET_DATE_TIME,
  PAY_PREMIUM_LIST,
  SAVE_PROPOSAL,
  GET_MEDICAL_QUESTIONS,
  ROLLOVER_COMPANY_LIST,
  PROPOSER_DROPDOWN_DETAIL,
  RENEWAL_MANDATE_DETAILS,
  CUSTOMER_ORGANISATIONAL_DROPDOWN_DETAIL,
  CHECK_IMD_CONFIG,
  PROFILE_DETAILS
} from '../queries';
import {useFetchQuery, useMutationQuery} from 'quanta-flows';
// import useMutationQuery from '../../../../../lib/graphql/useMutationQuery';
import {
  updateBuyHealthPolicy,
  updatePlanPremium,
} from 'quanta-flows/modules/proposal/health/state';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import {
  faCheck,
  faEdit,
  faFileMedical,
} from '@fortawesome/free-solid-svg-icons';
import { useParams } from 'react-router-dom';
import {ModalMedicalQuestionaire} from 'quanta-flows/modules/proposal/health';
import {CurrencyFormater,QuantaConfigContext} from 'quanta-flows';
// import { QuantaConfigContext } from '../../../../../lib/config/ConfigProvider';

export default function ReviewConfirmDetails({
  goToStep,
  proceedToNextStep,
  setProceedToNextStep,
  currentStepFunctions,
  setCurrentStepFunctions,
  setParentAlerts,
  setLoadingStep,
  setCustomLoadingMessage,
  planName,
  planCode,
  productCode,
  alerts,
  ...props
}) {
  const fetchQuery = useFetchQuery();
  const mutateQuery = useMutationQuery();
  const params = useParams();
  const { branding } = useContext(QuantaConfigContext);
  const plan_name = planName ? planName : params?.plan_name;
  const plan_code = planCode ? planCode : params?.plan_code;
  const proposal_number = params?.proposal_number;
  const product_code = '2880';
  const { loading, error, data } = useQuery(
    GET_BUY_HEALTH_POLICY_VAR_DETAILS,
  );
  if (data) {
    var prembuyHealthPolicy = data?.buyHealthPolicy;
    var prempquoteData = prembuyHealthPolicy?.quoteData;
    var premplanData = prembuyHealthPolicy?.planData;
    var plans = premplanData?.plans;
  }
  let Prem_data;
  Prem_data = plans?.find((p) => p.name === plan_name)?.premium
    ?.totalPremium
  let prem_feature 
 if(!prembuyHealthPolicy.proposerDetails.panNumber)
 {
    if(Prem_data >= 50000)
    {
    prem_feature = 1;
    }
 }
 let rev_manamount;
    rev_manamount = prembuyHealthPolicy?.renewalMandateDetails
   ?.renewalPaymentMandate?.toString() === 'true' ?
    1.5 * Prem_data
    :'';
  const {
    loading: dateTimeLoading,
    error: errorTimeLoading,
    data: dateTimeData,
  } = useQuery(GET_DATE_TIME);

  const {
    loading: loadingQuestions,
    error: errorQuestions,
    data: dataQuestions,
  } = useQuery(GET_MEDICAL_QUESTIONS, {
    variables: {
      input :{
      productCode: product_code,
      },
    },
    fetchPolicy: 'cache-first',
  });
 

  const {
    loading: loadingRollOverCompanyList,
    error: errorRollOverCompanyList,
    data: dataRollOverCompanyList,
  } = useQuery(ROLLOVER_COMPANY_LIST, { fetchPolicy: 'cache-first' });

  const {
    loading: dropDownLoadingCustomer,
    data: dropDownDetails,
  } = useQuery(CUSTOMER_INDIVIDUAL_DROPDOWN_DETAIL, {
    fetchPolicy: 'cache-first',
  });
  const {
    loading: renewDropDownLoadingCustomer,
    error: renewDropDownErrorCustomer,
    data: renewMandateDropDownDetails,
  } = useQuery(RENEWAL_MANDATE_DETAILS, {
    fetchPolicy: 'cache-first',
    variables: {
      productCode: product_code,
    },
  });
  const {
    loading: loadingProposerDetail,
    error: errorProposerDetail,
    data: dataProposerDetail,
  } = useQuery(PROPOSER_DROPDOWN_DETAIL, {
    variables: {
      productCode: product_code,
    },
    fetchPolicy: 'cache-first',
  });
  const {
    loading: loadingPaymentType,
    error: errorPaymentType,
    data: dataPaymentType,
  } = useQuery(PAY_PREMIUM_LIST, { fetchPolicy: 'cache-first' });
  const {
    loading: loadingCustTypeDomain,
    error: errorCustTypeDomain,
    data: dataCustTypeDomain,
  } = useQuery(GET_CUSTOMER_TYPE_DOMAIN, {
    fetchPolicy: 'cache-first',
  });
  const {
    loading: dropDownLoadingOrganisation,
    error: dropDownErrorOrganisation,
    data: dropDownDetailsOrganisation,
  } = useQuery(CUSTOMER_ORGANISATIONAL_DROPDOWN_DETAIL, {
    fetchPolicy: 'cache-first',
  });
  const {
    loading: loadingProfile,
    error: loadingError,
    data: dataProfileData,
  } = useQuery(PROFILE_DETAILS, {
    fetchPolicy: 'network-only',

  });
  let repeat = useResponsiveParams({ for_mobile: 2, for_desktop: 3 });

  const validate = (values) => {
    return {};
  };

  const getDomainData = (
    domainArr,
    searchText,
    searchType,
    returnType,
  ) => {
    return domainArr.find(
      (d) =>
        d[`${searchType}`]?.toString()?.toLowerCase() ===
        searchText?.toString()?.toLowerCase(),
    )
      ? domainArr.find(
          (d) =>
            d[`${searchType}`]?.toString()?.toLowerCase() ===
            searchText?.toString()?.toLowerCase(),
        )[`${returnType}`]
      : '';
  };

  const ReviewForm = ({ validate }) => {
    const [
      medicalQuestionaireDisplay,
      setMedicalQuestionaireDisplay,
    ] = useState(false);
    const ReviewProposerForm = () => {
      const data = [
        proposerDetailsMeta.isNewCustomer === false
          ? {
              grid_data: [
                {
                  label: 'Customer Number',
                  text: proposerDetails.id,
                },
                {
                  label: 'CRN',
                  text: proposerDetailsMeta?.crn,
                },
              ],
            }
          : null,
        proposerDetails?.customerType ===
        getDomainData(customerTypeList, 'Individual', 'value', 'code')
          ? {
              title: <Text type="normal">Personal Details</Text>,
              grid_data: [
                {
                  label: 'Title',
                  text: (
                    <span>
                      {proposerDetails.title !== ''
                        ? getDomainData(
                            salutationList,
                            proposerDetails?.title,
                            'code',
                            'value',
                          )
                        : ''}
                    </span>
                  ),
                },
                {
                  label: 'Gender',
                  text: (
                    <span>
                      {proposerDetails.gender !== ''
                        ? getDomainData(
                            genderList,
                            proposerDetails?.gender,
                            'code',
                            'value',
                          )
                        : ''}
                    </span>
                  ),
                },
                {
                  label: 'Date of Birth',
                  text: proposerDetails.proposerDOB,
                },
                {
                  label: 'First Name',
                  text: proposerDetails.firstName,
                },
                {
                  label: 'Middle Name',
                  text: proposerDetails.middleName,
                },
                {
                  label: 'Last Name',
                  text: proposerDetails.lastName,
                },
                {
                  label: 'Marital Status',
                  text: (
                    <span>
                      {proposerDetails.maritalStatus !== ''
                        ? getDomainData(
                            maritalStatusList,
                            proposerDetails?.maritalStatus,
                            'code',
                            'value',
                          )
                        : ''}
                    </span>
                  ),
                },
                {
                  label: 'Nationality',
                  text: (
                    <span>
                      {proposerDetails.nationality !== ''
                        ? getDomainData(
                            nationalityList,
                            proposerDetails?.nationality,
                            'code',
                            'value',
                          )
                        : ''}
                    </span>
                  ),
                },
                /*SADivya -CR P2_233 : KYC*/
                {
                  label: "Mother's Maiden Name",
                  text: proposerDetails?.motherMaidenName,
                },
                {
                  label: 'CKYC ID Number',
                  text: proposerDetails?.ckycIdNumber,
                },
                {
                  label: 'EIA Required',
                  text: proposerDetails?.eiaRequired,
                },
                {
                  label: 'EIA Number',
                  text: proposerDetails?.eiaNumber,
                }
                /*SADivya -CR P2_233 : KYC*/
              ],
            }
          : {
              title: <Text type="normal">Organisation Details</Text>,
              grid_data: [
                {
                  label: 'Organisation Name',
                  text: proposerDetails.orgName,
                },
                {
                  label: 'Organisation Type ',
                  text: getDomainData(
                    organisationList,
                    proposerDetails?.orgType,
                    'code',
                    'value',
                  ),
                },
                {
                  label: 'Contact Person Name',
                  text: proposerDetails.contactName,
                },
              ],
            },
        proposerDetails.customerType ===
        getDomainData(customerTypeList, 'Individual', 'value', 'code')
          ? null 
          /*SUDivya - CR P2_233 :KYC : Hide Identification Details */
            // {
            //   title: (
            //     <Text type="normal">Identification Details</Text>
            //   ),
            //   grid_type: 'data',
            //   grid_data: [
            //     {
            //       label: 'ID Proof Type',
            //       text: (
            //         <span>
            //           {proposerDetails.idProofType !== ''
            //             ? getDomainData(
            //                 idProofTypeList,
            //                 proposerDetails?.idProofType,
            //                 'code',
            //                 'value',
            //               )
            //             : ''}
            //         </span>
            //       ),
            //     },
            //     {
            //       label: 'ID Proof Number',
            //       text: proposerDetails?.idProofNumber
            //         ?.toString()
            //         ?.toUpperCase(),
            //     },
            //   ],
            // }
             /*EUDivya - CR P2_233 :KYC : Hide Identification Details */
          : {
              title: (
                <Text type="normal">Tax Identification Details</Text>
              ),
              grid_type: 'data',
              grid_data: [
                {
                  label: 'Registration Number',
                  text: proposerDetails.regNumber,
                },
                {
                  label: 'TAN Number',
                  text: proposerDetails.tanNumber?.toUpperCase(),
                },
                {
                  label: 'GST Number',
                  text: proposerDetails.gstNumber?.toUpperCase(),
                },
              ],
            },
        proposerDetails.customerType ===
        getDomainData(customerTypeList, 'Individual', 'value', 'code')
          ? {
              title: <Text type="normal">Internal Employee</Text>,
              grid_type: 'data',
              grid_data: [
                {
                  label:
                    'If the customer also an internal employee or staff of us, then provide the employee number',
                  text: proposerDetails?.employeeNumber
                    ?.toString()
                    ?.toUpperCase(),
                },
              ],
            }
          : null,
        proposerDetails.customerType ===
        getDomainData(customerTypeList, 'Individual', 'value', 'code')
          ? {
              title: (
                <Text type="normal">Tax Identification Details</Text>
              ),
              grid_type: 'data',
              grid_data: [
                {
                  label: 'PAN Card Number',
                  text: proposerDetails?.panNumber
                    ?.toString()
                    ?.toUpperCase(),
                },
                {
                  label: 'GST Number',
                  text: proposerDetails.gstNumber?.toUpperCase(),
                },
              ],
            }
          : {
            title: (
              <Text type="normal">Tax Identification Details</Text>
            ),
            grid_type: 'data',
            grid_data: [
              {
                label: 'PAN Card Number',
                text: proposerDetails?.panNumber
                  ?.toString()
                  ?.toUpperCase(),
              },
              {
                label: 'GST Number',
                text: proposerDetails.gstNumber?.toUpperCase(),
              }, 
              /*SADivya -CR P2_233 : KYC*/
                {
                  label: 'Certificate of Incorporation',
                  text: proposerDetails?.certificateOfInCorporation,
                },
                {
                  label: 'udyog Aadhaar number',
                  text: proposerDetails?.udyogAadhaarNumber,
                },
                {
                  label: 'CKYC ID Number',
                  text: proposerDetails?.ckycIdNumber,
                }, 
              /*EADivya -CR P2_233 : KYC*/
              ],
          },
        {
          grid_type: 'data',
          grid_data: [
            {
              label: 'Permanent Address',
              colSpan: repeat,
              text: [
                proposerDetails?.permAddressLine1?.trim(),
                proposerDetails?.permAddressLine2?.trim(),
                proposerDetails?.permAddressLine3?.trim(),
                proposerDetails?.permLandmark?.trim(),
                proposerDetails?.permCityTownVillage?.trim(),
                proposerDetails?.permDistrict?.trim(),
                proposerDetails?.permState?.trim(),
                proposerDetails?.permPincode,
              ]
                .filter((a) => a)
                .join(','),
            },
            {
              label: 'Communication Address',
              colSpan: repeat,
              text: [
                proposerDetails?.commAddressLine1?.trim(),
                proposerDetails?.commAddressLine2?.trim(),
                proposerDetails?.commAddressLine3?.trim(),
                proposerDetails?.commLandmark?.trim(),
                proposerDetails?.commCityTownVillage?.trim(),
                proposerDetails?.commDistrict?.trim(),
                proposerDetails?.commState?.trim(),
                proposerDetails?.commPincode,
              ]
                .filter((a) => a)
                .join(','),
            },
          ].filter((d) => d),
        },
        proposerDetails.customerType ===
        getDomainData(customerTypeList, 'Individual', 'value', 'code')
          ? {
              title: <Text type="normal">Contact Details</Text>,
              grid_type: 'data',
              grid_data: [
                {
                  label: 'Mobile Number',
                  text: proposerDetails.mobileNo,
                },
                {
                  label: 'Email Id',
                  text: proposerDetails.emailID,
                },
              ].filter((d) => d),
            }
          : {
              title: <Text type="normal">Contact Details</Text>,
              grid_type: 'data',
              grid_data: [
                {
                  label: 'Telephone Number',
                  text: proposerDetails.phoneNo,
                },
                {
                  label: 'Organisation Mobile Number',
                  text: proposerDetails.mobileNo,
                },
                {
                  label: 'FAX Number',
                  text: proposerDetails.faxNo,
                },
                {
                  label: 'Alternative Telephone Number',
                  text: proposerDetails.altPhoneNo,
                },
                {
                  label: 'Alternative Mobile Number',
                  text: proposerDetails.altMobileNo,
                },
                {
                  label: 'Organisation Email Id',
                  text: proposerDetails.emailID,
                },
                !buyHealthPolicy.proposalNumber
                  ? {
                      colSpan: repeat,
                      label: <div className="mt-4"></div>,
                      text: (
                        <Text
                          severity="action"
                          className="hover:underline cursor-pointer"
                          onClick={(_) => {
                            goToStep(0);
                            window.scrollTo({
                              top: 0,
                              behavior: 'smooth',
                            });
                          }}
                        >
                          <FontAwesomeIcon
                            icon={faEdit}
                            className="mr-1"
                          />
                          <span className="font-bold">
                            Edit Details
                          </span>
                        </Text>
                      ),
                    }
                  : null,
              ].filter((d) => d),
            },
      ].filter((d) => d);
      const other_props = {
        flow: 'cols',
        repeat,
        gapX: 6,
        gapY: 0,
        spaceY: 2,
        size: 'full',
        titleSeverity: 'info',
        textType: 'normal',
        useExpandablePaper: false,
      };
      return (
        <DataGridGroup
          {...{ data, ...other_props }}
          nullData={() => (
            <Text className="opacity-40">Not Captured</Text>
          )}
        />
      );
    };

    const RenewMandateReviewForm = ({ renewalMandateDetails }) => {
      const grid_data = [
        {
          label: (
            <Text type="label">
              Do you want to set up a renewal payment mandate in the
              name of{' '}
              {PRD_RenewalPaymentMandateTakenInTheNameOf
                ? PRD_RenewalPaymentMandateTakenInTheNameOf[0]?.value
                    ?.toString()
                    ?.toLowerCase()
                : ''}
              ?
            </Text>
          ),
          text: renewalMandateDetails?.renewalPaymentMandate
            ? 'Yes'
            : 'No',
        },
        // {
        //   label: 'Term for Mandate - Opted (Times)',
        //   text: getDomainData(
        //     PRD_TermForMandate,
        //     renewalMandateDetails?.termForMandateOpted,
        //     'code',
        //     'value',
        //   ),
        // },
        // {
        //   label: 'Type of Debit',
        //   text: (
        //     <span>
        //       {renewalMandateDetails.typeOfDebit !== ''
        //         ? getDomainData(
        //             typeOfDebit,
        //             renewalMandateDetails?.typeOfDebit,
        //             'code',
        //             'value',
        //           )
        //         : ''}
        //     </span>
        //   ),
        // },
        // {
        //   label:
        //     'Destination Bank Account Number/ Legal Account Number',
        //   text: renewalMandateDetails?.accountNumber,
        // },
        // {
        //   label: 'Direct Debit/  NACH - Destination Bank Name',
        //   text: renewalMandateDetails?.destinationBankName,
        // },
        // {
        //   label: 'Destination Bank IFSC code',
        //   text: renewalMandateDetails?.destinationIfscCode,
        // },
        // {
        //   label: 'Destination Bank MICR code',
        //   text: renewalMandateDetails?.destinationMicrCode,
        // },
        // {
        //   label: 'Branch Name',
        //   text: renewalMandateDetails?.destinationBranchName,
        // },
        // {
        //   label: 'Mandate Amount',
        //   text: CurrencyFormater(
        //     renewalMandateDetails?.mandateAmount,
        //     true,
        //     false,
        //     branding,
        //   ),
        // },
        // {
        //   label: 'Final Collection Date',
        //   text: renewalMandateDetails?.finalCollectionDate,
        // },
        // {
        //   label: 'Destination Bank Account Type',
        //   text: (
        //     <span>
        //       {renewalMandateDetails?.destinationBankAccountType !==
        //       ''
        //         ? getDomainData(
        //             destinationBankAccountType,
        //             renewalMandateDetails?.destinationBankAccountType,
        //             'code',
        //             'value',
        //           )
        //         : ''}
        //     </span>
        //   ),
        // },
        !buyHealthPolicy.proposalNumber
                  ? {
                      colSpan: repeat,
                      label: <div className="mt-4"></div>,
                      text: (
                        <Text
                          severity="action"
                          className="hover:underline cursor-pointer"
                          onClick={(_) => {
                            goToStep(2);
                            window.scrollTo({
                              top: 0,
                              behavior: 'smooth',
                            });
                          }}
                        >
                          <FontAwesomeIcon
                            icon={faEdit}
                            className="mr-1"
                          />
                          <span className="font-bold">
                            Edit Details
            </span>
                        </Text>
          ),
                    }
                  : null,
      ].filter((d) => d);

      return (
        <DataGrid
          data={grid_data}
          flow="cols"
          repeat={repeat}
          gapX={6}
          textType="normal"
          gapY={0}
          spaceY={2}
          nullData={() => (
            <Text className="opacity-40">Not Captured</Text>
          )}
        />
      );
    };

    const ReviewInsuredMembersForm = ({ insuredDetails }) => {
      const data = insuredDetails
        ? insuredDetails.map((m, _) => {
            return {
              title: (
                <Text type="normal">
                  {m.relationship}
                  {m?.memberStatus ? ` (${m?.memberStatus})` : ''}
                </Text>
              ),
              grid_data: [
                {
                  label: 'Title',
                  text: m.title,
                },
                {
                  label: 'Gender',
                  text: (
                    <span>
                      {m.gender !== ''
                        ? getDomainData(
                            genderList,
                            m?.gender,
                            'code',
                            'value',
                          )
                        : ''}
                    </span>
                  ),
                },
                {
                  label: 'Date of Birth',
                  text: m.dob,
                },
                {
                  label: 'First Name',
                  text: m.firstName,
                },
                {
                  label: 'Middle Name',
                  text: m.middleName,
                },
                {
                  label: 'Last Name',
                  text: m.lastName,
                },
                {
                  label: 'Marital Status',
                  text: (
                    <span>
                      {m.maritalStatus !== ''
                        ? getDomainData(
                            maritalStatusList,
                            m?.maritalStatus,
                            'code',
                            'value',
                          )
                        : ''}
                    </span>
                  ),
                },
                {
                  label: 'Height',
                  text: m.height ? `${m.height} cm(s)` : '',
                },
                {
                  label: 'Weight',
                  text: m.weight ? `${m.weight} Kg(s)` : '',
                },
                {
                  label: 'Occupation',
                  text: (
                    <Text
                      className={m?.occupation ? '' : 'opacity-40'}
                      type={'normal'}
                    >
                      {m.occupation
                        ? getDomainData(
                            PRD_OccupationList,
                            m?.occupation,
                            'code',
                            'value',
                          )
                        : 'Not Captured'}
                    </Text>
                  ),
                },
                {
                  label: 'If Other Occupation',
                  text: m.otherOccupation,
                },
                {
                  label: 'Pre-Existing Disease waiting period',
                  text:
                    m.pedWaitingPeriod !== ''
                      ? getDomainData(
                          PRD_PreExistDiseaseWaitPeriod,
                          m?.pedWaitingPeriod,
                          'code',
                          'value',
                        )
                      : '',
                },
                // {
                //   label: 'Cumulative Bonus',
                //   text:
                //     m?.cbBonusAmt !== '' || m?.cbBonusPct
                //       ? getDomainData(
                //           PRD_CumulativeBonus,
                //           m?.cbBonusAmt !== '' || m?.cbBonusPct,
                //           'code',
                //           'value',
                //         )
                //       : '',
                // },
                m?.ppcTestLevel
                  ? {
                      label: 'PPC Test Level',
                      text: m.ppcTestLevel,
                    }
                  : null,
                {
                  label: 'Portability Required?',
                  text: m.isPortabilityRequired ? 'Yes' : 'No',
                },
                !buyHealthPolicy.proposalNumber
                  ? {
                      colSpan: repeat,
                      label: <div className="mt-4"></div>,
                      text: (
                        <Text
                          severity="action"
                          className="hover:underline cursor-pointer"
                          onClick={(_) => {
                            goToStep(1);
                            window.scrollTo({
                              top: 0,
                              behavior: 'smooth',
                            });
                          }}
                        >
                          <FontAwesomeIcon
                            icon={faEdit}
                            className="mr-1"
                          />
                          <span className="font-bold">
                            Edit Details
                          </span>
                        </Text>
                      ),
                    }
                  : null,
              ].filter((d) => d),
            };
          })
        : [];

      const other_props = {
        flow: 'cols',
        repeat,
        gapX: 6,
        gapY: 0,
        spaceY: 2,
        size: 'full',
        titleSeverity: 'info',
        textType: 'normal',
        useExpandablePaper: false,
      };
      return (
        <DataGridGroup
          {...{ data, ...other_props }}
          nullData={() => (
            <Text className="opacity-40">Not Captured</Text>
          )}
        />
      );
    };

    const ReviewNomineeForm = ({ nomineeDetails }) => {
      const data = nomineeDetails
        ? nomineeDetails.map((m) => {
            return {
              title: <Text type="normal">{m.relationship}</Text>,
              grid_data: [
                {
                  label: 'Name',
                  text: m.name,
                },
                {
                  label: 'Date of Birth',
                  text: m.dob,
                },
                {
                  label: 'Relationship with Member',
                  text:
                    m.relationshipWithInsured !== ''
                      ? getDomainData(
                          PRD_NomiRelationWithMemb,
                          m?.relationshipWithInsured,
                          'code',
                          'value',
                        )
                      : '',
                },
                {
                  label: 'Name of Appointee(in case of Minor)',
                  text: m.nameOfAppointee,
                },
                {
                  label: 'Relationship with Nominee',
                  text:
                    m.relationshipWithAppointee !== ''
                      ? getDomainData(
                          PRD_ApointRelationWithMinNomi,
                          m?.relationshipWithAppointee,
                          'code',
                          'value',
                        )
                      : '',
                },
                !buyHealthPolicy.proposalNumber
                  ? {
                      colSpan: repeat,
                      label: <div className="mt-4"></div>,
                      text: (
                        <Text
                          severity="action"
                          className="hover:underline cursor-pointer"
                          onClick={(_) => {
                            goToStep(2);
                            window.scrollTo({
                              top: 0,
                              behavior: 'smooth',
                            });
                          }}
                        >
                          <FontAwesomeIcon
                            icon={faEdit}
                            className="mr-1"
                          />
                          <span className="font-bold">
                            Edit Details
                          </span>
                        </Text>
                      ),
                    }
                  : null,
              ].filter((d) => d),
            };
          })
        : [];

      const other_props = {
        flow: 'cols',
        repeat,
        gapX: 6,
        gapY: 0,
        spaceY: 2,
        size: 'full',
        titleSeverity: 'info',
        textType: 'normal',
        useExpandablePaper: false,
      };
      return (
        <DataGridGroup
          {...{ data, ...other_props }}
          nullData={() => (
            <Text className="opacity-40">Not Captured</Text>
          )}
        />
      );
    };

    const ReviewPreviousInsuranceForm = ({
      prevInsuranceDetails,
    }) => {
      const data = prevInsuranceDetails
        ? prevInsuranceDetails.map((prevInsured) => {
            return {
              title: (
                <Text type="normal">
                  {prevInsured.insuredRelationship} - Previous
                  Insurance Policy {'&'} Claims
                </Text>
              ),
              grid_data: [
                {
                  label: 'Previous Insurer Name',
                  text: getDomainData(
                    rolloverCompanyList,
                    prevInsured?.prevInsurerName,
                    'code',
                    'value',
                  ),
                },
                {
                  label: 'Previous Policy Number',
                  text: prevInsured?.prevPolicyNo,
                },
                {
                  label: 'Policy Start Date',
                  text: prevInsured?.prevPolicyStartDate,
                },
                {
                  label: 'Policy End Date',
                  text: prevInsured?.prevPolicyEndDate,
                },
                {
                  label: 'Sum Insured',
                  text: prevInsured?.prevPolicySI
                    ? CurrencyFormater(prevInsured?.prevPolicySI)
                    : '',
                },
                {
                  label: 'Claims lodged in the past policy?',
                  text: prevInsured?.prevClaimLodged,
                },
                {
                  label: 'Claim Amount',
                  text: prevInsured?.claimAmount
                    ? CurrencyFormater(prevInsured?.claimAmount)
                    : '',
                },
                {
                  label: 'Cumulative Bonus Amount',
                  text: prevInsured?.cbAmount
                    ? CurrencyFormater(prevInsured?.cbAmount)
                    : '',
                },
                !buyHealthPolicy.proposalNumber
                  ? {
                      colSpan: repeat,
                      label: <div className="mt-4"></div>,
                      text: (
                        <Text
                          severity="action"
                          className="hover:underline cursor-pointer"
                          onClick={(_) => {
                            goToStep(2);
                            window.scrollTo({
                              top: 0,
                              behavior: 'smooth',
                            });
                          }}
                        >
                          <FontAwesomeIcon
                            icon={faEdit}
                            className="mr-1"
                          />
                          <span className="font-bold">
                            Edit Details
                          </span>
                        </Text>
                      ),
                    }
                  : null,
              ].filter((d) => d),
            };
          })
        : [];

      const other_props = {
        flow: 'cols',
        repeat,
        gapX: 6,
        gapY: 0,
        spaceY: 2,
        size: 'full',
        titleSeverity: 'info',
        textType: 'normal',
        useExpandablePaper: false,
      };
      return (
        <DataGridGroup
          {...{ data, ...other_props }}
          nullData={() => (
            <Text className="opacity-40">Not Captured</Text>
          )}
        />
      );
    };

    const ReviewPortablityDetailsForm = ({ portabilityDetails }) => {
      const data = portabilityDetails
        ? portabilityDetails.map((portability) => {
            return {
              title: (
                <Text type="normal">
                  {portability.insuredRelationship}
                </Text>
              ),
              grid_data: [
                {
                  label: 'Member ID',
                  text: portability.memberId,
                },
                {
                  label: 'Insured Name',
                  text: portability.memberName,
                },
                {
                  label:
                    'Sum Insuured (including Cumulative Bonus, if any)',
                  text: CurrencyFormater(portability.sumInsuredIncCumBonusifany),
                },
                {
                  label: '30 Days Waiting Period',
                  text: portability.thirtyDaysWaitingPeriod,
                },
                {
                  label: '2 Years Waiting Period',
                  text: portability.twoYearsWaitingPeriod,
                },
                {
                  label: 'PED (4 Years) Waiting Period',
                  text: portability.ped4YearsWaitingPeriod,
                },
              ].filter((d) => d),
            };
          })
        : [];

      const other_props = {
        flow: 'cols',
        repeat,
        gapX: 6,
        gapY: 0,
        spaceY: 2,
        size: 'full',
        titleSeverity: 'info',
        textType: 'normal',
        useExpandablePaper: false,
      };

      return (
        <DataGridGroup
          {...{ data, ...other_props }}
          nullData={() => (
            <Text className="opacity-40">Not Captured</Text>
          )}
        />
      );
    };

    const HealthDeclarationForm = () => {
      const data = [
        {
          title: (
            <span className="flex flex-col space-y-4">
              <Text type="large">Health Declaration</Text>
              {/* <Text type="label" className="text-base text-black">
                Has any person proposed to be insured under the policy
                suffered from any medical conditions or disabilities
                of health problems listed below or has been
                hospitalised or has had any surgical operation be it
                intermittent recurring or otherwise?
              </Text> */}
              <Text type="label" className="text-base text-black">
            Any of the Insured member/s has medical condition or in not in good health?   
              </Text>
            </span>
          ),
          grid_data: [
            {
              type: 'render',
              component: () => (
                <div>
                  <RadioGroup
                    selected={isHealthDeclarationSelected}
                    disabled={true}
                    data={[
                      {
                        label: 'Yes',
                        value: 'Yes',
                      },
                      {
                        label: 'No',
                        value: 'No',
                      },
                    ]}
                  />
                </div>
              ),
            },
          ],
        },
      ];
      const other_props = {
        flow: 'cols',
        repeat,
        gapX: 6,
        gapY: 0,
        spaceY: 2,
        size: 'full',
        titleSeverity: 'info',
        useExpandablePaper: false,
      };
      return <InputGridGroup {...{ data, ...other_props }} />;
    };

    const TitlePart = () => {
      const data = [
        {
          title: 'Business Type',
          grid_data: [
            {
              type: 'render',
              component: () => (
                <Text>
                  <FontAwesomeIcon
                    icon={faCheck}
                    className="mr-2 text-success"
                  />
                  {quotationType}
                </Text>
              ),
            },
          ],
        },
        {
          title: 'Proposal Type',
          grid_data: [
            {
              type: 'radiogroup',
              name: 'proposalPaymentType',
              disabledGlobal:
                buyHealthPolicy.proposalNumber.length > 0,
              data: dataPaymentType
                ? dataPaymentType.ProposalPaymentTypeList?.map(
                    (paymentMethod) => {
                      return {
                        label: paymentMethod.value
                          ? paymentMethod.value
                          : '',
                        value: paymentMethod.code
                          ? paymentMethod.code
                          : '',
                      };
                    },
                  )
                : [],
            },
          ],
        },
        {
          title: 'Review Proposal',
          grid_type: 'data',
          grid_data: [
            {
              label: 'Policy Start Date',
              name: 'startDate',
              //  text: dateTimeData?.datetimeValue?.date,
               text: buyHealthPolicy?.policy?.startDate
               ?buyHealthPolicy?.policy?.startDate
               :dateTimeData?.datetimeValue?.date,
            },
            {
              label: 'Tenure',
              text: buyHealthPolicy?.quoteData?.cover?.tenure,
            },
            buyHealthPolicy?.policy?.endDate
              ? {
                  label: 'Policy End Date',
                  name: 'endDate',
                  text: buyHealthPolicy?.policy?.endDate,
                }
              : null,
            {
              label: 'Lead Generator',
              colSpan: 1,
              text: (
                <div className={'mt-1'}>
                  <QuantaInput
                    type={'text'}
                    size={'full'}
                    name={'leadGenerator'}
                    disabled={
                      buyHealthPolicy?.proposalNumber?.length > 0
                    }
                  />
                </div>
              ),
            },
          ].filter((d) => d),
        },
      ];

      const other_props = {
        flow: 'cols',
        repeat,
        gapX: 6,
        gapY: 0,
        spaceY: 2,
        size: 'full',
        titleSeverity: 'info',
        textType: 'normal',
        useExpandablePaper: false,
      };
      return <MixedGridGroup {...{ data, ...other_props }} />;
    };

    const RenewMandate = () => {
      const data = [
        {
          grid_type: 'data',
          grid_data: [
            {
              text: (
                <RenewMandateReviewForm
                  renewalMandateDetails={renewalMandateDetails}
                />
              ),
              colSpan: repeat,
            },
          ],
        },
      ];

      const other_props = {
        flow: 'cols',
        textType: 'normal',
        repeat,
        gapX: 6,
        gapY: 0,
        spaceY: 2,
        size: 'full',
        titleSeverity: 'info',
        useExpandablePaper: false,
      };

      return <MixedGridGroup {...{ data, ...other_props }} />;
    };

    const data = [
      {
        title: <Text type="large">Proposer Customer</Text>,
        grid_type: 'data',
        grid_data: [
          {
            text: <ReviewProposerForm />,
            colSpan: repeat,
          },
        ],
      },
      {
        title: <Text type="large">Insured Members Details</Text>,
        grid_type: 'data',
        grid_data: [
          {
            text: (
              <ReviewInsuredMembersForm
                insuredDetails={insuredDetails}
              />
            ),
            colSpan: repeat,
          },
        ],
      },
      {
        title: <Text type="large">Nominee Details</Text>,
        grid_type: 'data',
        grid_data: [
          {
            text: (
              <ReviewNomineeForm nomineeDetails={nomineeDetails} />
            ),
            colSpan: repeat,
          },
        ],
      },
      prevInsuranceDetails && prevInsuranceDetails.length > 0
        ? {
            title: (
              <Text type="large">Previous Insurance Details</Text>
            ),
            grid_type: 'data',
            grid_data: [
              {
                text: (
                  <ReviewPreviousInsuranceForm
                    {...{ prevInsuranceDetails }}
                  />
                ),
                colSpan: repeat,
              },
            ],
          }
        : null,
      proposal_number &&
      portabilityDetails &&
      portabilityDetails.length > 0
        ? {
            title: <Text type="large">Underwriting Assessment</Text>,
            grid_type: 'data',
            grid_data: [
              {
                text: (
                  <ReviewPortablityDetailsForm
                    {...{ portabilityDetails }}
                  />
                ),
                colSpan: repeat,
              },
            ],
          }
        : null,
      {
        title: <Text type="large">Renewal Mandate Details</Text>,
        grid_type: 'data',
        grid_data: [
          {
            text: (
              <RenewMandate
                renewalMandateDetails={renewalMandateDetails}
              />
            ),
            colSpan: repeat,
          },
        ],
      },
    ].filter((d) => d);

    const other_props = {
      flow: 'cols',
      textType: 'normal',
      repeat,
      gapX: 6,
      gapY: 0,
      spaceY: 2,
      size: 'full',
      titleSeverity: 'info',
      useExpandablePaper: true,
    };

    return (
      <>
        <QuantaForm className="space-y-4">
          <TitlePart />
          <MixedGridGroup {...{ data, ...other_props }} />
          <HealthDeclarationForm />
          <Button
            type="button"
            disabled={
              isHealthDeclarationSelected?.toLowerCase() === 'no'
            }
            flat={true}
            iconPre={
              <FontAwesomeIcon
                icon={faFileMedical}
                className={
                  isHealthDeclarationSelected?.toLowerCase() === 'no'
                    ? 'mr-1'
                    : 'ml-2 mr-1'
                }
              />
            }
            onClick={(_) => setMedicalQuestionaireDisplay(true)}
          >
            {' '}
            Medical Questionaire
          </Button>
        </QuantaForm>
        <div>
          <ModalMedicalQuestionaire
            {...{
              productCode:product_code,
              medicalQuestionaireDisplay,
              setMedicalQuestionaireDisplay,
              questions: productQuestionList,
              readOnlyMode: true,
            }}
          />
        </div>
      </>
    );
  };

  if (
    loading ||
    dropDownLoadingCustomer ||
    loadingCustTypeDomain ||
    dateTimeLoading ||
    loadingPaymentType ||
    loadingQuestions ||
    loadingRollOverCompanyList ||
    loadingProposerDetail ||
    renewDropDownLoadingCustomer ||
    dropDownLoadingOrganisation||
    loadingProfile
  ) {
    return (
      <div className="min-h-screen">
        <Loading />
      </div>
    );
  }

  if (
    error ||
    errorCustTypeDomain ||
    errorTimeLoading ||
    errorPaymentType ||
    errorQuestions ||
    errorRollOverCompanyList ||
    errorProposerDetail ||
    dropDownErrorOrganisation ||
    renewDropDownErrorCustomer
  ) {
    return (
      <Error
        error={
          error ||
          errorCustTypeDomain ||
          errorTimeLoading ||
          errorPaymentType ||
          errorQuestions ||
          errorRollOverCompanyList ||
          errorProposerDetail ||
          dropDownErrorOrganisation ||
          renewDropDownErrorCustomer
        }
      />
    );
  }

  const { productQuestionList } = dataQuestions;
  const { buyHealthPolicy } = data;
  const { rolloverCompanyList } = dataRollOverCompanyList;
  const {
    proposerDetails,
    proposerDetailsMeta,
    insuredDetails,
    nomineeDetails,
    prevInsuranceDetails,
    renewalMandateDetails,
    portabilityDetails,
    isHealthDeclarationSelected,
    quotationType,
  } = buyHealthPolicy;
  const {
    idProofTypeList,
    maritalStatusList,
    nationalityList,
    genderList,
    salutationList,
  } = dropDownDetails;
  const {
    typeOfDebit,
    PRD_TermForMandate,
    destinationBankAccountType,
    PRD_RenewalPaymentMandateTakenInTheNameOf,
  } = renewMandateDropDownDetails;
  const {
    PRD_PreExistDiseaseWaitPeriod,
    PRD_OccupationList,
    PRD_CumulativeBonus,
    PRD_NomiRelationWithMemb,
    PRD_ApointRelationWithMinNomi,
  } = dataProposerDetail;
  const { customerTypeList } = dataCustTypeDomain;
  const initialValues = {
    proposalPaymentType: buyHealthPolicy?.proposalPaymentType
      ? buyHealthPolicy?.proposalPaymentType
      : dataPaymentType?.ProposalPaymentTypeList[0]?.code,
    leadGenerator :buyHealthPolicy?.leadGenerator
    ? buyHealthPolicy?.leadGenerator
    : '',
  };
  const { organisationList } = dropDownDetailsOrganisation;
  const obj = { dataProfileData };
  const value = Object.values(obj);
  
  const mapUserId = value?.[0]?.userMyDetail?.userId;

  const saveProposalVariables = (
    buyHealthPolicyData,
    getDateTimeData,
    values,
  ) => {
    const getInsuredDetailsObj = (
      insuredDetails,
      nomineeDetails,
      prevInsuranceDetails,
      medicalQuestionaire,
      planData,
      isHealthDeclarationSelected,
    ) => {
      let insuredDetailsResponseArr = [];
      insuredDetails.forEach((insured) => {
        const {
          ppcTestLevel,
          memberID,
          memberStatus,
          ...restInsured
        } = insured;
        let insuredObj = { ...restInsured };

        const nomineeObj = nomineeDetails?.find(
          (nominee) =>
            nominee?.relationship?.toLowerCase() ===
            insured?.relationship?.toLowerCase(),
        );
        const { relationship, ...restNomineeObj } = nomineeObj;
        insuredObj.nomineeDetails = {
          ...restNomineeObj,
          insuredRelationship: relationship,
        };

        const prevInsuranceInput = prevInsuranceDetails?.find(
          (prevInsured) =>
            prevInsured?.insuredRelationship?.toLowerCase() ===
            insured?.relationship?.toLowerCase(),
        );

        insuredObj.prevInsuranceInput = {
          prevInsurerName: prevInsuranceInput?.prevInsurerName,
          prevPolicyNo: prevInsuranceInput?.prevPolicyNo,
          prevPolicySI: prevInsuranceInput?.prevPolicySI,
          prevClaimLodged:
            prevInsuranceInput?.prevClaimLodged?.toLowerCase() ===
            'yes'
              ? true
              : false,
          claimAmount: prevInsuranceInput?.claimAmount,
          prevPolicyStartDate:
            prevInsuranceInput?.prevPolicyStartDate,
          prevPolicyEndDate: prevInsuranceInput?.prevPolicyEndDate,
          cbAmount: prevInsuranceInput?.cbAmount,
        };
        let medicalQuestionaireObj = isHealthDeclarationSelected
          ? medicalQuestionaire?.find(
              (m) =>
                m?.relationship?.toLowerCase() ===
                insured?.relationship?.toLowerCase(),
            )
          : { relationship: insured?.relationship, questions: [] };

        if (
          medicalQuestionaireObj &&
          medicalQuestionaireObj?.questions?.length > 0
        ) {
          medicalQuestionaireObj = {
            ...medicalQuestionaireObj,
            questions: medicalQuestionaireObj?.questions?.map(
              (question) => {
                return {
                  srNo: question?.srNo,
                  answer: question?.answer?.answerText,
                };
              },
            ),
          };
          medicalQuestionaireObj = {
            ...medicalQuestionaireObj,
            questions:
              medicalQuestionaireObj?.questions
                ?.find((q) => q?.srNo?.toLowerCase() === 'master')
                ?.answer?.toLowerCase() !== 'ye'
                ? medicalQuestionaireObj?.questions?.filter(
                    (q) => q?.srNo?.toLowerCase() !== '',
                  )
                : [],
          };
        }
        insuredObj.medicalQuestionaire = medicalQuestionaireObj
          ? medicalQuestionaireObj
          : { relationship: insured?.relationship, questions: [] };

        const { plans } = planData;
        insuredObj.addOnCovers = plans
          ?.find(
            (p) =>
              p?.name?.toLowerCase() === plan_name?.toLowerCase(),
          )
          ?.packs?.filter((pack) =>
            pack?.index?.includes(insured?.relationship),
          )
          .flatMap((pack) =>
            pack.addOnCovers.filter(
              (addOnCover) => addOnCover.selected,
            ),
          );
        if (!insuredObj.addOnCovers) {
          insuredObj.addOnCovers = [];
        }

        insuredDetailsResponseArr.push(insuredObj);
      });
      return insuredDetailsResponseArr;
    };
   // const {crn,isNewCustomer, ...restProposerMetaData} =
   const { isNewCustomer,ciuType,isCRNVerified, ...restProposerMetaData } =
     buyHealthPolicyData?.proposerDetailsMeta;
    return {
      input: {
        proposerDetails: {
          ...restProposerMetaData,
          ...buyHealthPolicyData?.proposerDetails,
          isThinCustomer: false,
          isCRNVerified : isCRNVerified === null ? false : 
          isCRNVerified === "" ? false: isCRNVerified,
        },
        insuredDetails: getInsuredDetailsObj(
          buyHealthPolicyData?.insuredDetails,
          buyHealthPolicyData?.nomineeDetails,
          buyHealthPolicyData?.prevInsuranceDetails,
          buyHealthPolicyData?.medicalQuestionaire,
          buyHealthPolicyData?.planData,
          buyHealthPolicyData?.isHealthDeclarationSelected?.toLowerCase() ===
            'yes'
           ||  buyHealthPolicyData?.isHealthDeclarationSelected?.toLowerCase() ==='no',
        ),
        plan: {
          name: plan_name,
          code: plan_code,
          premium:parseFloat( buyHealthPolicyData?.planData?.plans?.find(
            (plan) =>
              plan?.name?.toLowerCase() === plan_name?.toLowerCase(),
          )?.premium)
        },
        intermediary: {
          intermediaryCode:
            buyHealthPolicyData?.intermediaryDetails?.code,
          locationCode:
            buyHealthPolicyData?.intermediaryDetails?.location,
          fieldUserCode:
            buyHealthPolicyData?.intermediaryDetails?.fieldUserCode,
            fieldUserName:
            buyHealthPolicyData?.intermediaryDetails?.fieldUserName,
          fieldUserLocation:
            buyHealthPolicyData?.intermediaryDetails?.fieldUserLocation,
        },
        zone: buyHealthPolicyData?.quoteData?.location?.zone?.trim(),
        quotationType: buyHealthPolicyData?.quotationType,
        UserId:mapUserId?mapUserId:'',

        sumInsured: parseFloat(
          buyHealthPolicyData?.quoteData?.cover?.sum_insured,
        ),
        deductSumInsured: parseFloat(
          buyHealthPolicyData?.quoteData?.deductSumInsured,
        ),
        startDate: buyHealthPolicyData?.quotationType?.toLowerCase()==='roll over'
        ? buyHealthPolicy?.policy?.startDate
         :getDateTimeData?.datetimeValue?.date,
        startTime: '00:00',
        coverType: buyHealthPolicyData?.quoteData?.cover?.type,
        tenure: buyHealthPolicyData?.quoteData?.cover?.tenure,
        proposalPaymentType: values?.proposalPaymentType,
        leadGenerator: values?.leadGenerator, /*SA CR P2_169A*/
        isHealthDeclarationSelected:
          buyHealthPolicyData?.isHealthDeclarationSelected?.toLowerCase() ===
          'yes',
          //  || buyHealthPolicyData?.isHealthDeclarationSelected?.toLowerCase() ==='no',
        quoteNumber: buyHealthPolicyData?.quoteNumber,
        productCode: product_code,
        existingPolicyNumber:
          buyHealthPolicyData?.existingPolicyNumber,
          isExistingEmployee:
          buyHealthPolicy?.quoteData?.isExistingEmployee?.toLowerCase() ===
          'yes'
            ? true
            : false,
        employeeNumber:
          buyHealthPolicyData?.proposerDetails?.employeeNumber,
        proposerPincode:
          buyHealthPolicyData?.quoteData?.location?.pincode,
        /* Renew mandate */
        renewalMandateDetails: {
          renewalPaymentMandate:
            buyHealthPolicyData?.renewalMandateDetails
              ?.renewalPaymentMandate,
          renewalPaymentMandateTakenInNameOf:
            buyHealthPolicyData?.renewalMandateDetails
              ?.renewalPaymentMandateTakenInNameOf,
          termForMandateOpted:
            buyHealthPolicyData?.renewalMandateDetails
              ?.termForMandateOpted,
          typeOfDebit:
            buyHealthPolicyData?.renewalMandateDetails?.typeOfDebit,
          accountNumber:
            buyHealthPolicyData?.renewalMandateDetails?.accountNumber,
          destinationBankName:
            buyHealthPolicyData?.renewalMandateDetails
              ?.destinationBankName,
          destinationIfscCode:
            buyHealthPolicyData?.renewalMandateDetails
              ?.destinationIfscCode,
          destinationMicrCode:
            buyHealthPolicyData?.renewalMandateDetails
              ?.destinationMicrCode,
          destinationBranchName:
            buyHealthPolicyData?.renewalMandateDetails
              ?.destinationBranchName,
          mandateAmount: parseFloat(rev_manamount
           // buyHealthPolicyData?.renewalMandateDetails?.mandateAmount,
          ),
          finalCollectionDate:
            buyHealthPolicyData?.renewalMandateDetails
              ?.finalCollectionDate,
          destinationBankAccountType:
            buyHealthPolicyData?.renewalMandateDetails
              ?.destinationBankAccountType,
        },
      },
    };
  };

  const onSubmit = async (values) => {
    if (prem_feature === 1){
      setParentAlerts([
        {
          header: 'Error',
          id: Date.now(),
          content: (
            <div className="flex flex-row flex-wrap space-y-2 w-full h-full">
              PanCard Number is Mandatory for premium amount greater than 50000
            </div>
          ),
          type: 'error',
          timeout: null,
          disableClose: false,
        },
      ]);
      setLoadingStep(false);
      goToStep(0)
      return false;
    }
    else{
    if (!buyHealthPolicy.proposalNumber) {
      try {
        let getDateTime = fetchQuery({
          query: GET_DATE_TIME,
        });
        let { data: getDateTimeData } = await getDateTime;
        /*SA Divya  CR P2_169A  : Check IMD Config*/
        let ImdConfigQuery = fetchQuery({
          query: CHECK_IMD_CONFIG,
          fetchPolicy: 'cache-first',
          variables: {
            intermediaryCode: buyHealthPolicy?.intermediaryDetails?.code,
          },
        });
        setLoadingStep(true);
        let { data: dataImdCongig } = await ImdConfigQuery;
        setLoadingStep(false);
        if(dataImdCongig?.checkConfigImd?.isConfiguredIMD 
          && !values?.leadGenerator ){
          setParentAlerts([
            {
              header: 'Unable to Proceed',
              id: Date.now(),
              content: (
                <div className="flex flex-row flex-wrap space-y-2 w-full h-full">
                  {`Lead generator is Mandatory. 
                  Please enter the Lead generator before Proceeding`}
                </div>
              ),
              type: 'warning',
              timeout: null,
              disableClose: false,
            },
          ]);
          return  false;
        };
        /*EA Divya CR P2_169A  : Check IMD Config*/
        const variables = saveProposalVariables(
          buyHealthPolicy,
          getDateTimeData,
          values,
        );
        let doSaveProposal = mutateQuery({
          mutation: SAVE_PROPOSAL,
          variables,
        });
        setCustomLoadingMessage('Saving Proposal');
        window.scrollTo({ top: 0, behavior: 'smooth' });
        setLoadingStep(true);
        let { data } = await doSaveProposal;
        setLoadingStep(false);
          if (data?.saveProposalST?.warningMsg) {
        setParentAlerts([
              ...alerts,
              {
                header: 'Proposal Saved Successfully',
                content: (
                  <div className="flex flex-col w-full h-full">
                    <Text type="normal">
                      <FontAwesomeIcon
                        icon={faCheck}
                        className="text-success"
                      />{' '}
                      Proposal Number:{' '}
                      {data?.saveProposalST?.proposalNumber}
                    </Text>
                  </div>
                ),
                type: 'success',
                timeout: null,
                disableClose: false,
              },
              {
                content: (
                  <Text type="normal">
                    {data?.saveProposalST?.warningMsg}
                  </Text>
                ),
                type: 'warning',
                timeout: null,
                disableClose: false,
              },
            ]);
          }
          else {
            if (
              data?.saveProposalST?.isApplicableForPayment === false && productCode?.toString() === '2880'
            ) {
              setParentAlerts([
                ...alerts,
                {
                  header: 'Medical/Underwriting Approval',
                  id: Date.now(),
                  content: (
                    <div className="flex flex-row flex-wrap space-y-2 w-full h-full">
                      <span>{'Your case needs Medical/Underwriting approval. Until then, only the Digital Link is available for payment (includes - ASBA Payment)'}</span>
                    </div>
                  ),
                  type: 'warning',
                  timeout: 100000000,
                  disableClose: true,
                },
          {
            header: 'Proposal Save Success',
            id: Date.now(),
            content: (
              <div className="flex flex-col w-full h-full">
                <Text type="normal">
                  <FontAwesomeIcon
                    icon={faCheck}
                    className="text-success"
                  />{' '}
                        Proposal Number: {data?.saveProposalST?.proposalNumber}
                </Text>
              </div>
            ),
            type: 'success',
            timeout: null,
            disableClose: false,
          },
        ]);
            }
            else {
              setParentAlerts([
                ...alerts,
                {
                  header: 'Proposal Saved Successfully',
                  content: (
                    <div className="flex flex-col w-full h-full">
                      <Text type="normal">
                        <FontAwesomeIcon
                          icon={faCheck}
                          className="text-success"
                        />{' '}
                        Proposal Number:{' '}
                        {data?.saveProposalST?.proposalNumber}
                      </Text>
                    </div>
                  ),
                  type: 'success',
                  timeout: null,
                  disableClose: false,
                },
              ]);
            }
          }
        updateBuyHealthPolicy({
            proposalNumber: data?.saveProposalST?.proposalNumber,
            proposalStatus: data?.saveProposalST?.proposalStatus,
          proposalPaymentType: values.proposalPaymentType,
          leadGenerator: values.leadGenerator,
          isProposalApplicableForPayment:
              data?.saveProposalST?.isApplicableForPayment === null ||
                data?.saveProposalST?.isApplicableForPayment === undefined ||
                data?.saveProposalST?.isApplicableForPayment
              ? true
              : false,
          policy: {
            startDate: buyHealthPolicy?.policy?.startDate ? 
                         buyHealthPolicy?.policy?.startDate :
                         getDateTimeData?.datetimeValue?.date,
            endDate: data?.saveProposalST?.proposalEndDate,
            time: getDateTimeData?.datetimeValue?.time,
          },
          proposerDetails: {
              id: data?.saveProposalST.customerID,
          },
        });
          updatePlanPremium(plan_name, data?.saveProposalST?.premium);
        setProceedToNextStep([
          ...proceedToNextStep.slice(0, 3),
          true,
          ...proceedToNextStep.slice(3),
        ]);
        return true;
      } catch (error) {
        updateBuyHealthPolicy({
          proposalPaymentType: values.proposalPaymentType,
          leadGenerator: values.leadGenerator,
        });
        //Unexpected Token
        if(error?.message){
          if(error.message.includes("Unexpected token")){
            error.message='Please try again after sometime'
          }
        }
        //Unexpected Token
        setParentAlerts([
          {
            header: 'Error',
            id: Date.now(),
            content: (
              <div className="flex flex-row flex-wrap space-y-2 w-full h-full">
                {error.message}
              </div>
            ),
            type: 'error',
            timeout: null,
            disableClose: false,
          },
        ]);
        setLoadingStep(false);
        return false;
      }
    } else {
      setParentAlerts([]);
      setProceedToNextStep([
        ...proceedToNextStep.slice(0, 3),
        true,
        ...proceedToNextStep.slice(4),
      ]);
      window.scrollTo({ top: 0, behavior: 'smooth' });
      return true;
    }
  }
  };

  return (
    <div>
      <QuantaFormik
        innerRef={props.forwardedRef}
        enableReinitialize={true}
        {...{
          initialValues,
          validate,
          onSubmit,
          validator: () => ({}),
        }}
      >
        <ReviewForm {...{ validate }} />
      </QuantaFormik>
    </div>
  );
}
